const MAX_METADATA_URI_LENGTH = 200;
// Only allow http: in development for local testing (security: HTTP vulnerable to MITM)
const ALLOWED_URI_PROTOCOLS =
  process.env.NODE_ENV === 'development' ? ['https:', 'ipfs:', 'arweave:', 'http:'] : ['https:', 'ipfs:', 'arweave:'];

/**
 * Validate metadata URI before submitting to Solana.
 * @throws Error if URI is invalid
 */
export function validateMetadataUri(uri: string): void {
  if (!uri || typeof uri !== 'string') {
    throw new Error('Metadata URI is required');
  }

  if (uri.length > MAX_METADATA_URI_LENGTH) {
    throw new Error(`Metadata URI exceeds maximum length of ${MAX_METADATA_URI_LENGTH} characters`);
  }

  try {
    const parsed = new URL(uri);
    if (!ALLOWED_URI_PROTOCOLS.includes(parsed.protocol)) {
      throw new Error(
        `Invalid URI protocol. Allowed: ${ALLOWED_URI_PROTOCOLS.map((p) => p.replace(':', '')).join(', ')}`,
      );
    }
  } catch (e) {
    if ((e as Error).message.includes('Invalid URL')) {
      throw new Error('Invalid metadata URI format');
    }
    throw e;
  }

  // Check for control characters
  if (/[\x00-\x1f\x7f]/.test(uri)) {
    throw new Error('Metadata URI contains invalid characters');
  }
}
